module.exports = __webpack_public_path__ + "assets/img/code-kfgj-72351783.png";